import { CognitoUserPool } from 'amazon-cognito-identity-js'
export const poolData = {
  UserPoolId: process.env.NODE_ENV === 'development' ? 'eu-central-1_atQ8fgqjt' : 'eu-central-1_atQ8fgqjt',
  ClientId: process.env.NODE_ENV === 'development' ? '4t9blldd3tj5lanpq005rhklcp' : '4t9blldd3tj5lanpq005rhklcp'
}

export default new CognitoUserPool(poolData)
